export default __webpack_public_path__ + "static/steven-binotto-bz-yzg-tu-dj-0-unsplash-1649edd1cac1399f640c99b6708ecfd7.png";